import { render, staticRenderFns } from "./alert_sounds_settings.vue?vue&type=template&id=a50ce496"
import script from "./alert_sounds_settings.vue?vue&type=script&lang=js"
export * from "./alert_sounds_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports